export const AppStats = {
  // ✅ KEEP: Only general app/invitation actions
  GET_STATS: "app/GET_STATS",
  GET_STATS_SUCCESS: "app/GET_STATS_SUCCESS",
  GET_MUTUAL_MANAGEMENT: "app/GET_MUTUAL_MANAGEMENT",
  GET_MUTUAL_MANAGEMENT_SUCCESS: "app/GET_MUTUAL_MANAGEMENT_SUCCESS",
  CO_MANAGEMENT_STATUS: "app/CO_MANAGEMENT_STATUS",
  CO_MANAGEMENT_STATUS_SUCCESS: "app/CO_MANAGEMENT_STATUS_SUCCESS",
  
  
};

// ✅ KEEP: Only general actions
export const getStats = (payload) => ({
  type: AppStats.GET_STATS,
  payload,
});

export const getMutualManagement = (payload) => ({
  type: AppStats.GET_MUTUAL_MANAGEMENT,
  payload,
});

export const getCoManagement = (payload) => ({
  type: AppStats.CO_MANAGEMENT_STATUS,
  payload,
});
